import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';


const VerifyPasswordResetContainer = ({ verifier }) => (
  <Redirect to={{
    pathname: '/reset-password',
    state: {
      verifier,
    },
  }}
  />
);


const mapStateToProps = (store, { location: { search } }) => ({
  verifier: qs.parse(search, { ignoreQueryPrefix: true }).verifier,
});

VerifyPasswordResetContainer.propTypes = {
  verifier: PropTypes.string,
};

VerifyPasswordResetContainer.defaultProps = {
  verifier: null,
};

export default withRouter(
  connect(mapStateToProps)(VerifyPasswordResetContainer),
);
export { VerifyPasswordResetContainer };
